module.exports = __webpack_public_path__ + "static/media/USDC.61255a20.svg";